module.exports = __webpack_public_path__ + "static/js/2.ccde5e31.chunk.worker.js"